module.exports = __webpack_public_path__ + "img/07.363cda8c.jpg";